module.exports = __webpack_public_path__ + "img/HTML.f5e73526.svg";